module.exports = __webpack_public_path__ + "img/7.11ee9171.jpg";